import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiHeart, FiMaximize } from 'react-icons/fi';

const ProductDetails = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-amber-50 rounded-3xl border border-amber-100 shadow-sm relative overflow-hidden">
          <div className="grid md:grid-cols-2 items-center">
            
            <div className="p-8 md:p-12 relative z-10 flex flex-col justify-center">
              <h2 className="text-2xl md:text-3xl font-serif font-bold text-stone-900 mb-8">
                Product Details
              </h2>
              <ul className="space-y-6">
                <li className="flex gap-4">
                  <SafeIcon icon={FiHeart} className="text-amber-600 text-xl flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-bold text-stone-900">Beautifully Crafted</h4>
                    <p className="text-stone-600 mt-1">Handmade-quality designs for all the book lovers out there. Exquisite typography and comforting imagery.</p>
                  </div>
                </li>
                <li className="flex gap-4">
                  <SafeIcon icon={FiMaximize} className="text-amber-600 text-xl flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-bold text-stone-900">Versatile Sizing</h4>
                    <p className="text-stone-600 mt-1">They measure approximately 2" x 6" by default, but because they are digital files, you can scale them larger or smaller before printing to fit your specific Bible or journal perfectly!</p>
                  </div>
                </li>
                <li className="flex gap-4">
                  <SafeIcon icon={FiHeart} className="text-amber-600 text-xl flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-bold text-stone-900">Color Variations</h4>
                    <p className="text-stone-600 text-sm mt-1">Please note that printed colors may vary slightly from what you see on your monitor, depending on your printer and paper quality.</p>
                  </div>
                </li>
              </ul>
            </div>

            {/* Updated container to strictly be 9:16 aspect ratio so the image is never cropped */}
            <div className="relative w-full aspect-[9/16] bg-stone-100">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/bf058984a4ffdbb1bcf737e98ba89b4a0e9a3794368100afc61d724fc2136ffb549bddff932effd18582b107d1ceb382/images/aW1hZ2UvcG5n/7848a7ed0c9f2aa2f5b67cdc9416b743.png" 
                alt="Close up of a hand holding the Bible Emergency Numbers bookmark" 
                className="absolute inset-0 w-full h-full object-cover object-center"
              />
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductDetails;